import { getSection } from '@wix/ambassador-appmarket-v1-section/http';
import { SectionsPlacement } from '@wix/ambassador-appmarket-v1-section/types';
export const getBenefitApps = async (httpClient) => {
    try {
        const { data: { sections } } = await httpClient.request(getSection({
            placement: SectionsPlacement.APP_BENEFITS,
            // customParams: { LineItemsAsFamily: 'any' },
        }));
        return sections.map(({ app: { appId } }) => ({ appId }));
    }
    catch (e) {
        return [];
    }
};
//# sourceMappingURL=benefit-apps-api.js.map